
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[authorID]/batch-group",
      function () {
        return require("private-next-pages/[authorID]/batch-group.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[authorID]/batch-group"])
      });
    }
  